/**
 * Route guard for internal commercial/evaluation surfaces.
 *
 * Hiding a nav item is not a boundary: this blocks the route itself for the
 * external subcontractor role, so competing-bidder amounts, evaluation
 * rationale, and decision queues cannot be reached by typing a URL. The
 * backend remains the data-level enforcement layer.
 */
import { useAuth } from "../../App";
import { isSubcontractor } from "../../lib/roles";
import { NoAccess } from "./WorkflowStates";

const InternalOnly = ({ children }) => {
  const { user } = useAuth();
  if (isSubcontractor(user)) {
    return (
      <NoAccess message="This area contains internal commercial evaluation. Your organization sees its own submissions and assignments through the portal and marketplace views." />
    );
  }
  return children;
};

export default InternalOnly;
